/**
 * Looping Lottie for the mobile About section (< 1200px); replaces the static
 * card stack with a single looping animation, full width, natural aspect ratio.
 * Desktop is untouched (CSS keeps this hidden).
 */

import lottie from 'lottie-web/build/player/lottie_light';

const MOBILE_MAX_WIDTH = 1199;

/**
 * @return {{ destroy: () => void }}
 */
export function initJitterMobileAbout() {
	const container = document.querySelector('.about-mobile-lottie');
	const url = container?.getAttribute('data-lottie-src');

	if (!container || !url) {
		return { destroy() {} };
	}

	const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
	/** @type {import('lottie-web').AnimationItem | null} */
	let anim = null;

	const start = () => {
		if (anim) {
			return;
		}
		anim = lottie.loadAnimation({
			container,
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: url,
		});
	};

	const stop = () => {
		anim?.destroy();
		anim = null;
	};

	const onMqChange = () => {
		if (mq.matches) {
			start();
		} else {
			stop();
		}
	};

	onMqChange();
	mq.addEventListener('change', onMqChange);

	return {
		destroy() {
			mq.removeEventListener('change', onMqChange);
			stop();
		},
	};
}
